<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/fcl/components/user/ImageUploader'
import AreaSelector from '@/fcl/components/user/AreaSelector'
import BottomToolbar from '@/fcl/components/user/BottomToolbar'
import CheckboxListSelector from '@/fcl/components/user/CheckboxListSelector'
import { QNImageUtil } from '@/fcl/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        [Dialog.Component.name]: Dialog.Component,
        'image-uploader': ImageUploader,
        'area-selector': AreaSelector,
        'bottom-toolbar': BottomToolbar,
        'checkbox-list-selector': CheckboxListSelector,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organization: {
                name: null,
                logoUrl: null,
                logo: null,
                area: null,
                areaId: null,
                contact: null,
                position: null,
                sportType: null,
                areaList: null,
                areaIdList: null,
                sportTypeOptions: null,
                sportTypeList: null,
                isOwner: null,
            },
            isEdit: null,
            showPopup: null,
            confirmMessage: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.organization.name) {
                    Toast(this.locale['organization-name-required'])
                }
                else if (!this.organization.area) {
                    Toast(this.locale['organization-area-required'])
                }
                else if (!this.organization.sportTypeList || this.organization.sportTypeList == 0) {
                    Toast(this.locale['organization-sport-type-required'])
                }
                else if (!this.organization.contact) {
                    Toast(this.locale['organization-contact-required'])
                }
                else if (!this.organization.position) {
                    Toast(this.locale['organization-position-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            // console.log('onDeleteBtnClick')
            this.showPopup = true
        },
        onDialogConfirm() {
            // console.log('onDialogConfirm')
            this.$emit('custom-event', {
                type: 'delete'
            })
        },
        onDialogCancel() {
            this.confirmMessage = ''
        },
        onAreaSelectorDataChange(data) {
            console.log('onAreaSelectorDataChange', this.isEdit, data)
            this.organization.areaId = this.convertAreaCode2Id(data.code)
            console.log('organization.areaIdList', this.organization.areaIdList, data.code)
            console.log('organization.areaId', this.organization.areaId, data.code)
            this.organization.area = data.label
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', this.isEdit, data)
            this.organization.logo = data
        },
        onSportTypeDataChange(data) {
            console.log('onSportTypeDataChange', data)
            this.organization.sportTypeList = data
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.organization.name 
                && this.organization.area 
                && this.organization.sportTypeList
                && this.organization.sportTypeList.length > 0
                && this.organization.contact
                && this.organization.position) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            console.log('submitData', this.organization)
            if (this.validateSubmitRequired()) {
                // this.organization.sportType = this.locale['sport-type-1']
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.organization
                })
            }
        },
        convertAreaCode2Id(code) {
            console.log('convertAreaCode2Id', code)
            if (this.organization && this.organization.areaIdList) {
                const areaIdList = this.organization.areaIdList
                if (areaIdList.province_list[code]) {
                    return areaIdList.province_list[code]
                }
                else if (areaIdList.city_list[code]) {
                    return areaIdList.city_list[code]
                }
                else if (areaIdList.county_list[code]) {
                    return areaIdList.county_list[code]
                }
            }
            return '1'
        },
        convertAreaId2Code(id) {
            if (this.organization && this.organization.areaIdList) {
                const areaIdList = this.organization.areaIdList
                for (let p in areaIdList.province_list) {
                    if (areaIdList.province_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.city_list) {
                    if (areaIdList.city_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.county_list) {
                    if (areaIdList.county_list[p] == id) {
                        return p
                    }
                }
            }
        },
    },
}
</script>

<template>
    <div class="organization-edit">
        <van-form>
            <van-field 
                name="organization-name" 
                v-model="organization.name" 
                :label="locale['organization-name-label']" :placeholder="locale['organization-name-placeholder']"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="50" 
            />
            <image-uploader
                :label="locale['organization-logo-label']"
                :description="locale['organization-logo-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.organization.logoUrl, 400, 400)"
                @change-data="onLogoUploaderDataChange"
            />
            <area-selector
                :label="locale['city-region']"
                :all="locale['all']"
                :allArea="locale['whole-nation']"
                :areaList="organization.areaList"
                :selectedAreaCode="convertAreaId2Code(organization.areaId)"
                :selectedAreaLabel="organization.area"
                @change-data="onAreaSelectorDataChange"
            />
            <checkbox-list-selector
                :label="locale['sport-type']"
                :value="organization.sportTypeList"
                :list="organization.sportTypeOptions"
                @change-data="onSportTypeDataChange"
            />
            <van-field 
                name="organization-contact" 
                v-model="organization.contact" 
                :label="locale['organization-contact-label']" :placeholder="locale['organization-contact-placeholder']"
                clearable
                input-align="right"
                maxlength="30"
            />
            <van-field 
                name="organization-position" 
                v-model="organization.position" 
                :label="locale['organization-position-label']" :placeholder="locale['organization-position-placeholder']"
                clearable
                input-align="right"
                maxlength="30"
            />
        </van-form>
        <bottom-toolbar 
            v-if="isEdit && organization.isOwner"
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <van-dialog 
            v-model="showPopup" 
            :title="locale['delete-organization']" 
            :show-confirm-button="confirmMessage == organization.name"
            show-cancel-button
            @confirm="onDialogConfirm"
            @cancel="onDialogCancel"
        >
            <div class="text-center"><span class="normal-text main-secondary-color">{{ locale['delete-organization-confirm-message'] }}</span></div>
            <van-field 
                v-model="confirmMessage" 
                :placeholder="locale['delete-organization-placeholder']"
                center
                input-align="center"
            />
        </van-dialog>
    </div>
</template>